import YubinBango from "@tential/yubinbango/yubinbango-core2"

/**
 * 都道府県リスト
 */
export const PREFECTURES_FROM_YUBIN_BANGO = YubinBango.Core.REGION.filter((el) => el !== null)

/**
 * 住所文字数制限
 */
export const ADDRESS_LENGTH_LIMIT = 48

/**
 * 住所文字数制限の警告メッセージ
 */
export const ADDRESS_LENGTH_WARNING_MESSAGE = `住所が長すぎます。番地や部屋番号は残し、建物名などを短くしてください（{length}文字オーバー）`

/**
 * 名前のプレースホルダー
 */
export const NAME_PLACEHOLDER = "例) 山田 花子"

/**
 * フリガナのプレースホルダー
 */
export const NAME_KANA_PLACEHOLDER = "例) ヤマダ ハナコ"

/**
 * 郵便番号のプレースホルダー
 */
export const ZIP_CODE_PLACEHOLDER = "例) 1410001"

/**
 * 都道府県のプレースホルダー
 */
export const PREFECTURE_PLACEHOLDER = "郵便番号から入力してください"

/**
 * 市区町村のプレースホルダー
 */
export const ADDRESS_LINE1_PLACEHOLDER = "郵便番号から入力してください"

/**
 * 番地・建物名・号室のプレースホルダー
 */
export const ADDRESS_LINE2_PLACEHOLDER = "例) 6-7-29 △△ビル5階"

/**
 * 電話番号のプレースホルダー
 */
export const TEL_PLACEHOLDER = "例) 0362775504"
